import { StoryCardPlaceholder } from '../../../uikit/story-card-placeholder/StoryCardPlaceholder';
import React, { FunctionComponent, useEffect, useRef } from 'react';
import { Button } from '../../../ui';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { Brief } from '../../../../services/models/brief';
import { Story } from '../../../../services/models/story';
import { FeatureFlag } from '../../../../services/models/feature-flags';
import BriefStoryCard from '../../../brief-story-card/BriefStoryCard';

interface Props {
  active: boolean;
  draftBrief: Brief | null;
  storiesPreview?: Story[];
  isFetchingPreview: boolean;
  refreshPreview: (briefId: number) => void;
  onComplete: () => void;
}

const MAX_PREVIEW_COUNT = 3;

const RefineBriefStep: FunctionComponent<Props> = ({
  onComplete,
  active,
  draftBrief,
  storiesPreview,
  isFetchingPreview,
  refreshPreview,
}) => {
  const changesHashRef = useRef<string>('');

  const newReportShowPreviewScreenFlag = useFeatureFlag(FeatureFlag.NewReportShowPreviewScreen);

  useEffect(() => {
    if (draftBrief) {
      const changesHash = [...draftBrief.keywords.map(x => x.keyword)].join(', ');

      if (changesHashRef.current !== changesHash) {
        refreshPreview(draftBrief.id);
        changesHashRef.current = changesHash;
      }
    }
  }, [draftBrief, refreshPreview]);

  if (!active || !draftBrief) {
    return <></>;
  }

  const getButtons = () => {
    if (!newReportShowPreviewScreenFlag) {
      return;
    }

    return (
      <div className="mt-12 flex flex-col items-center justify-center">
        <Button variant="purple" onClick={() => onComplete()}>
          Looks good!
        </Button>
      </div>
    );
  };

  const getContent = () => {
    if (isFetchingPreview || !storiesPreview) {
      return (
        <>
          <StoryCardPlaceholder isPreview />
          <StoryCardPlaceholder isPreview />
          <StoryCardPlaceholder isPreview />
        </>
      );
    }

    if (storiesPreview.length === 0) {
      return (
        <div className="flex flex-col items-center justify-center p-4 text-sm text-gray-500">
          There are no stories with these keywords.
        </div>
      );
    }

    const result = storiesPreview.map(x => (
      <BriefStoryCard key={x.id} story={x} briefId={draftBrief.id} isPreview />
    ));

    if (newReportShowPreviewScreenFlag) {
      return result.slice(0, MAX_PREVIEW_COUNT);
    }

    return result;
  };

  return (
    <div className="flex flex-col items-stretch justify-center pt-4">
      <div className="mx-auto w-full max-w-xl">{getContent()}</div>
      {getButtons()}
    </div>
  );
};

export default RefineBriefStep;
